<template>
  <v-app>

    <v-app-bar app height="48" color="black white--text" clipped-left v-if="user != null">
      <div class="d-flex align-center">
        <v-img src="@/assets/still-small.png" height="30" width="20" contain/>
        <div class="text-subtitle ml-4" v-show="!$vuetify.breakpoint.mobile">{{company.customerName}} @ {{company.companyName}}</div>
      </div>

      <v-spacer/>

      <!-- Inventory menu -->
      <div style="position:relative">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mr-2 white--text" text>
              <v-icon class="mr-1">mdi-tag</v-icon>
              <template v-if="!$vuetify.breakpoint.mobile">Inventory</template>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item :to="{name:'InventoryProducts'}"><v-list-item-title>Products</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'InventoryItems'}"><v-list-item-title>Items</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'InventorySpirits'}"><v-list-item-title>Sprits</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'InventoryWine'}"><v-list-item-title>Wine</v-list-item-title></v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <!-- Production menu -->
      <div style="position:relative">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mr-2 white--text" text>
              <v-icon class="mr-1">mdi-cogs</v-icon>
              <template v-if="!$vuetify.breakpoint.mobile">Production</template>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item :to="{name:'ProductionMashing'}"><v-list-item-title>Mashing</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'ProductionDistilling'}"><v-list-item-title>Distilling</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'ProductionBlending'}"><v-list-item-title>Blending</v-list-item-title></v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <!-- Documents menu -->
      <v-btn class="mr-2 white--text" text :to="{name:'Documents'}">
        <v-icon class="mr-1">mdi-file-document-outline</v-icon>
        <template v-if="!$vuetify.breakpoint.mobile">Documents</template>
      </v-btn>

      <!-- User menu -->
      <div style="position:relative">
        <v-menu offset-y v-model="userMenu">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="mr-1">
              <v-avatar color="white" size="36">{{user.name.substring(0,1)}}</v-avatar>
            </v-btn>
          </template>
          <v-card width="200">
            <v-list dense>
              <v-list-item :to="{name:'UserInfo'}"><v-list-item-title>Personal information</v-list-item-title></v-list-item>
              <v-list-item @click="showPassword = true"><v-list-item-title>Change password</v-list-item-title></v-list-item>
              <template v-if="$store.state.companies.length > 1">
                <v-divider/>
                <v-list-item :to="{name:'PickCustomer'}"><v-list-item-title>Switch customer/distillery</v-list-item-title></v-list-item>
              </template>
              <v-divider/>
              <v-list-item @click="about()"><v-list-item-title>About PŪRTRAK</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item @click="$auth.logout();$store.commit('clearUser');$auth.login()"><v-list-item-title>Sign out</v-list-item-title></v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

    </v-app-bar>

    <v-main>
      <v-snackbar :timeout="10000" v-model="showError" :color="errorType" top>
        {{error.message}}
        <template v-slot:action="{attrs}">
          <v-btn plain v-bind="attrs" @click="showError=false;">Close</v-btn>
        </template>
      </v-snackbar>

      <v-snackbar :timeout="-1" color="error" :value="company && company.status==='Inactive'" top>
        Distillery is inactive
      </v-snackbar>

      <v-snackbar :timeout="-1" color="warning" content-class="text-body-1" centered v-model="displayMessage">
        {{message.message}}
        <template v-slot:action="{attrs}">
          <v-btn plain v-bind="attrs" @click="displayMessage=false;">Close</v-btn>
        </template>
      </v-snackbar>

      <v-card min-height="100%" :disabled="company && company.status==='Inactive' && $route.name !== 'Settings'">
        <router-view/>
      </v-card>
    </v-main>

    <configuration-user-password v-model="showPassword"/>
    <component :is="dialog"  @done="dialog = null"/>

    <v-snackbar v-model="newVersion" top color="gray" timeout="-1">
      Click <strong>REFRESH</strong> to load the newest version of PŪRTRAK.
      <div class="text-right mt-3"><v-btn @click="reload()" color="primary">Refresh</v-btn></div>
    </v-snackbar>
  </v-app>
</template>

<style scoped>
.v-list-item {
  flex: 0;
}
</style>

<script>
import ConfigurationUserPassword from '@/views/login/ChangeUserPassword'

export default {
  name: 'App',
  components: {ConfigurationUserPassword},
  data() {
    return {
      showError: false,
      errorType: null,
      showSwitch: false,
      showPassword: false,
			dialog: null,
      userMenu: false,
      displayMessage: false
    }
  },
  computed: {
    newVersion() {
      return this.$store.state.newVersion;
    },
    company() {
      return this.$store.getters.company;
    },
    error() {
      return this.$store.state.error;
    },
    user() {
      return this.$store.state.user;
    },
    message() {
      return this.$store.state.message;
    },
    showMessage() {
      return this.$store.state.showMessage;
    }
  },
  watch: {
    error() {
      this.errorType = this.error.type;
      this.showError = this.error.type != undefined;
      setTimeout(() => {this.error.type = null;}, 1000);    // Wait a sec before clearing type to prevent other messages
    },
    showMessage() {
      if (this.showMessage) {
        this.displayMessage = true;
        this.$store.commit('clearShowMessage');
      }
    }
  },
  methods: {
    about() {
      this.dialog = () => import('@/views/login/LoginAbout');
    },
    reload() {
      location.reload(true);
    }
  }
}
</script>

<style>
.cursor-pointer {
  cursor:pointer;
}
.purtrak-scrollable {
  overflow-y:scroll;
  height:calc(100vh - 158px);
}
.overflow-y {
  overflow-y:scroll;
}
.purtrak-table {
  margin-left:12px;
}
.purtrak-table table {
  padding-right:14px;
}
.total-row {
  font-weight: bold;
}
.total-row:hover {
  background-color: #fff !important;
}
.table-footer-column {
  border-top:1px solid #ddd;
}

.selected-list-item td:first-child {
  border-left:5px solid #3676cb;
  padding-left:11px !important;
}
.selected-list-item-mobile td {
  border-left:5px solid #3676cb;
  padding-left:11px !important;
}

.list-column {
  border-bottom:none !important;
}
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
.v-tabs.full-height-tab  .v-window-item {
  height: calc(100vh - 206px);
  overflow-y: auto;
}
.row + .row {
  margin-top:0px;
}
.no-sort .v-data-table-header-mobile {
  display:none
}
</style>
